import type { EvictorAdvancedEvictionConfigEntry } from '@cast/types-workload-eviction';

import type { Result } from '../_types';
import { advancedEvictionConfigSchema } from '../_validation';

import { parseYaml } from './advancedConfig';

/**
 * Validates a YAML string against the full config schema (API shape and
 * completeness) and returns the eviction config entries.
 * This is the authoritative save gate.
 */
export const parseYamlToAdvancedConfig = (
  yaml: string
): Result<EvictorAdvancedEvictionConfigEntry[], string> => {
  const yamlResult = parseYaml(yaml);

  if (!yamlResult.success) {
    return { success: false, error: 'Invalid YAML syntax' };
  }

  if (!yamlResult.value) {
    return { success: true, value: [] };
  }

  try {
    const validatedConfig = advancedEvictionConfigSchema.validateSync(
      yamlResult.value
    );
    return {
      success: true,
      value: validatedConfig.evictionConfig ?? [],
    };
  } catch (error) {
    const message =
      error instanceof Error ? error.message : 'Invalid advanced configuration';
    return { success: false, error: message };
  }
};
